import { ExportIcon } from '@cycle-app/ui/icons';
import { getDocSlug } from '@cycle-app/utilities';

import { useNavigate } from 'src/hooks';
import { useRelease } from 'src/hooks/releases/useRelease';
import { useReleaseNote } from 'src/hooks/releases/useReleaseNote';

import { Action } from './ReleaseNote.styles';

export const ReleaseNoteDocOpen = ({
  releaseId, noteId,
}: {
  releaseId: string;
  noteId: string;
}) => {
  const { navigateToReleaseDoc } = useNavigate();
  const { release } = useRelease(releaseId);
  const { releaseNote } = useReleaseNote(noteId);
  if (!release || !releaseNote?.doc) return null;
  const docSlug = getDocSlug(releaseNote.doc);
  return (
    <Action
      onClick={(e) => {
        navigateToReleaseDoc(releaseId, noteId, docSlug, {}, e.metaKey);
      }}
      tooltip="Open doc"
      tooltipPlacement="bottom"
    >
      <ExportIcon size={14} />
    </Action>
  );
};
